var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossReferenceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.52,
    height: 115.035,
    viewBox: "0 0 82.52 115.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153",
    transform: "translate(23369 -18464.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M820.071,2068.365l-.017-4.739,0,0Z",
    transform: "translate(-24180.76 16451.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(-23369 18464.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M796.039,2055.312l0,0-.013-5.748Z",
    transform: "translate(-795.426 -2003.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M876.586,1949.88a.6.6,0,0,0-.593-.593.641.641,0,0,0-.593.617l.095,24.715a9.009,9.009,0,0,1-4.08,7.045L806.757,2019c-1.887,1.078-3.51.509-3.51-1.969l-.166-51.826,72.248-41.7.047,13.686a.593.593,0,0,0,1.186,0c-.161-39.557.009,3.161-.071-23.316a3.681,3.681,0,0,0-1.518-3.273c-.236-.238-1.086-.646-7.756-4.554a3.694,3.694,0,0,0-3.724.308l-9.559,5.526a.586.586,0,0,0-.213.807.608.608,0,0,0,.806.237l9.559-5.55a2.554,2.554,0,0,1,2.538-.309l5.621,3.321a5.057,5.057,0,0,0-1.044.474l-64.682,37.357a10.139,10.139,0,0,0-4.645,8.015c0,.014-.012.026-.012.04,0,.244.007,7.82.007,7.577l-6.5-3.819c0-5.24,0-.971-.024-8.278a9,9,0,0,1,4.08-7.021l48.79-28.178a.59.59,0,0,0-.593-1.02l-48.79,28.178a10.1,10.1,0,0,0-4.672,8.065c.06,22.55.07,26.354.071,26.636a.6.6,0,0,0,.593.593.588.588,0,0,0,.593-.593l-.047-17.007,6.523,3.819.166,51.8a5.108,5.108,0,0,0,.095,1.067l-5.645-3.3a2.53,2.53,0,0,1-.972-2.3l-.071-24.241a.619.619,0,0,0-.593-.593h-.024a.6.6,0,0,0-.569.616l.071,24.217a3.609,3.609,0,0,0,1.565,3.321c.594.349,7.614,4.578,7.851,4.578a3.813,3.813,0,0,0,3.582-.356l64.658-37.358a10.133,10.133,0,0,0,4.673-8.065Zm-73.529,6.381a9.042,9.042,0,0,1,4.056-7.021l64.682-37.334c2.348-1.176,3.465-.051,3.51,1.969v8.278l-72.224,41.675c0-.244-.025-8.04-.024-7.543Z",
    transform: "translate(-794.162 -1905.673)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M836.085,2046.973a5.744,5.744,0,0,0-2.68,4.649c0,2.017,1.631,2.826,3.3,1.826a5.807,5.807,0,0,0,2.657-4.578C839.358,2047,837.942,2045.951,836.085,2046.973Zm-1.494,4.649a4.717,4.717,0,0,1,2.087-3.629c.86-.526,1.494-.223,1.494.878a4.525,4.525,0,0,1-2.064,3.558C835.206,2052.951,834.59,2052.721,834.59,2051.622Z",
    transform: "translate(-24189.834 16463.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M864.838,2030.311a5.87,5.87,0,0,0-2.7,4.673c0,1.948,1.608,2.84,3.3,1.826a5.734,5.734,0,0,0,2.657-4.578C868.087,2030.17,866.471,2029.35,864.838,2030.311Zm-1.518,4.649a4.662,4.662,0,0,1,2.111-3.605c.869-.553,1.471-.215,1.471.878a4.561,4.561,0,0,1-2.064,3.558C863.87,2036.351,863.32,2035.947,863.32,2034.96Z",
    transform: "translate(-24209.361 16474.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M893.616,2013.728a5.838,5.838,0,0,0-2.68,4.649c0,2.124,1.769,2.767,3.3,1.85a5.814,5.814,0,0,0,2.657-4.6C896.844,2013.8,895.5,2012.692,893.616,2013.728Zm-1.494,4.649a4.717,4.717,0,0,1,2.087-3.629c.994-.552,1.494-.084,1.494.877a4.568,4.568,0,0,1-2.064,3.582C892.743,2019.727,892.122,2019.469,892.122,2018.377Z",
    transform: "translate(-24228.936 16485.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M908.206,2057.928a.6.6,0,0,1-.3-.079.593.593,0,0,1-.3-.514l-.022-8.125a.591.591,0,0,1,.3-.514l21.094-12.18-.019-6.707a.6.6,0,0,1,.229-.471.57.57,0,0,1,.513-.1L943,2032.7a.591.591,0,0,1,.334.915L930.1,2052.375a.6.6,0,0,1-.662.224.593.593,0,0,1-.415-.564l-.017-6.026-5.235,3.023a.593.593,0,0,1-.593-1.026l6.122-3.535a.592.592,0,0,1,.89.512l.015,5.189,11.663-16.537-11.719-3.056.017,6.281a.588.588,0,0,1-.3.514l-21.094,12.18.018,6.758,5.7-3.292a.593.593,0,1,1,.593,1.026l-6.59,3.8A.594.594,0,0,1,908.206,2057.928Z",
    transform: "translate(-24240.256 16474.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M864.394,2132.317a.546.546,0,0,1-.149-.02l-13.291-3.466a.592.592,0,0,1-.335-.915l13.229-18.758a.582.582,0,0,1,.662-.223.593.593,0,0,1,.415.564l.017,6.026,20.523-11.849a.593.593,0,0,1,.889.512l.023,8.124a.59.59,0,0,1-.3.514l-8.626,4.981a.593.593,0,0,1-.593-1.026l8.328-4.81-.019-6.758-20.524,11.849a.592.592,0,0,1-.89-.512l-.015-5.188L852.081,2127.9l11.718,3.056-.018-6.281a.59.59,0,0,1,.3-.514l5.368-3.1a.593.593,0,0,1,.593,1.026l-5.071,2.928.019,6.707a.591.591,0,0,1-.593.594Z",
    transform: "translate(-24201.459 16424.291)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossReferenceIcon);
export default __webpack_public_path__ + "static/media/cross-reference-icon.881e63c3ec1aa5844c5748ee99a26bcc.svg";
export { ForwardRef as ReactComponent };